import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitStashAction extends WorkerAction {
  type: GitAction.Stash;
  params?: string[];
}

export class GitStashActionError extends WorkerActionError {}

export async function GitStashActionFn({ lg, params, util }: WorkerFnParams<GitStashAction>): Promise<string> {
  try {
    const stashOutput = lg.callAndCaptureOutput(['stash', ...(params || [])]);
    await util.syncfs(false);
    return stashOutput;
  } catch (err) {
    throw new GitStashActionError(err);
  }
}
